import { forwardRef } from 'react';
import '../../css/AvailabilityTemplates.css';

/**
 * The fixed-size root every availability image template draws inside. The
 * ref is what gets rasterised.
 *
 * @param {object} props
 * @param {number} props.width - px
 * @param {number} props.height - px
 * @param {string} [props.className] - template-specific class
 * @param {{cssVars: Object<string, string>}} [props.palette] - snapshot.palette; its colour variables are set on the root
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
const TemplateFrame = forwardRef(function TemplateFrame({ width, height, className = '', palette, children }, ref) {
  return (
    <div ref={ref} className={`avt-frame ${className}`.trim()} style={{ ...(palette?.cssVars || {}), width, height }}>
      {children}
    </div>
  );
});

export default TemplateFrame;
